import { usePropertyUndergroundStorageTanks } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButton, ToggleButtonItem, ToggleButtonLabelSize } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface UndergroundStorageTanksProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const UndergroundStorageTanks: React.FC<UndergroundStorageTanksProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Any underground storage tanks?';
    const [undergroundStorageTanks, set_undergroundStorageTanks] = usePropertyUndergroundStorageTanks(propertyGuid);

    const undergroundStorageTanksOptions: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
        },
        {
            id: 'Unsure',
            text: 'Unsure',
            hint: 'Unsure if Tanks',
        },
    ];

    const getUndergroundStorageTanksValue = () => {
        if (undergroundStorageTanks) {
            return undergroundStorageTanksOptions.find((o) => o.id.toLowerCase() == undergroundStorageTanks)?.text;
        } else {
            return '';
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={getUndergroundStorageTanksValue()}
                />
            ) : (
                <ToggleButton
                    id='toggleButtonUndergroundStorageTanks'
                    items={undergroundStorageTanksOptions}
                    selectedItems={[undergroundStorageTanks]}
                    stylingMode='outlined'
                    selectionMode='single'
                    onItemClick={(e) => set_undergroundStorageTanks(e?.itemData.id)}
                    width='220px'
                    required={required}
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
